<template>
  <!-- 联系人列表：客户的联系人，关键决策人管理 -->
  <div class="contact-list">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true" page-name="contactList">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="联系人姓名/手机号" @keydown.enter="resetSearch" clearable>
            <template #prefix>联系人</template>
          </el-input>
          <!-- 客户选择器给的是客户档案id，与后端 customerId 的口径一致 -->
          <customer-select v-model="searchInfo.customerId" placeholder="全部客户" @change="resetSearch">
            <template #prefix>所属客户</template>
          </customer-select>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
          <page-button type="write" el-type="success" @click="openDialog()">+ 新建联系人</page-button>
        </template>
      </search-condition>

      <list-table v-loading="loading" background-color="#FFF">
        <yq-table :data="dataList" :empty-text="'暂无数据'" height="100%" page-name="contactList">
          <yq-table-column label="联系人" prop="merchantRemarkName" min-width="160rem">
            <template v-slot="{row}">
              {{ row.merchantRemarkName }}
              <el-tag v-if="Number(row.keyContact) === KEY_CONTACT.YES" size="small" type="warning">关键人</el-tag>
            </template>
          </yq-table-column>
          <yq-table-column label="所属客户" prop="customerName" min-width="200rem" :show-overflow-tooltip="true">
            <template v-slot="{row}">{{ row.customerName || '—' }}</template>
          </yq-table-column>
          <yq-table-column label="职位" prop="customerPosition" min-width="140rem">
            <template v-slot="{row}">{{ dictName(positionList, row.customerPosition) || '—' }}</template>
          </yq-table-column>
          <yq-table-column label="手机号" prop="merchantRemarkPhone" min-width="140rem"/>
          <yq-table-column label="操作" prop="options" align="center" fixed="right" width="140rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button @click="openDialog(row)">编辑</table-button>
              <table-button el-type="danger" message="是否确认删除该联系人" @click="deleteRow(row.id)">删除</table-button>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>

      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>

    <!-- 新增/编辑联系人 -->
    <el-dialog v-model="showDialog" :title="dialogData.id ? '编辑联系人' : '新建联系人'" dialog-width="2" :close-on-click-modal="false">
      <form-items :data="dialogData" :columns="2" label-width="2.4rem" icon-width="0" ref="dialogForm">
        <form-item label="所属客户" :required="true" name="customerId" error-message="请选择所属客户" :show-block="true">
          <!-- 联系人换客户等于换一条数据，编辑时不允许改 -->
          <customer-select v-model="dialogData.customerId" :disabled="!!dialogData.id" placeholder="请选择所属客户" style="width: 100%"/>
        </form-item>
        <form-item label="联系人名称" :required="true" name="merchantRemarkName" error-message="请输入联系人名称">
          <el-input v-model="dialogData.merchantRemarkName" placeholder="请输入联系人名称"/>
        </form-item>
        <form-item label="手机号" :required="true" name="merchantRemarkPhone" error-message="请输入联系人手机号">
          <el-input v-model="dialogData.merchantRemarkPhone" placeholder="请输入联系人手机号"/>
        </form-item>
        <form-item label="职位">
          <el-select v-model="dialogData.customerPosition" placeholder="请选择职位" clearable style="width: 100%">
            <el-option v-for="d in positionList" :key="d.userCode" :label="d.dictName" :value="d.userCode"/>
          </el-select>
        </form-item>
        <form-item label="关键联系人" desc-message="关键决策人，联系人概况里单独统计">
          <el-select v-model="dialogData.keyContact" placeholder="请选择" clearable style="width: 100%">
            <el-option :value="KEY_CONTACT.YES" label="是"/>
            <el-option :value="KEY_CONTACT.NO" label="否"/>
          </el-select>
        </form-item>
        <form-item label="性别">
          <el-select v-model="dialogData.merchantGender" placeholder="请选择性别" clearable style="width: 100%">
            <el-option :value="1" label="男"/>
            <el-option :value="2" label="女"/>
          </el-select>
        </form-item>
        <form-item label="生日">
          <el-date-picker v-model="dialogData.merchantBirthday" type="date" value-format="YYYY-MM-DD" placeholder="请选择日期" style="width: 100%"/>
        </form-item>
        <form-item label="地区">
          <administrative v-model="dialogData.merchantRegion"/>
        </form-item>
        <form-item label="联系地址" :show-block="true">
          <el-input v-model="dialogData.merchantAddress" placeholder="请输入联系地址"/>
        </form-item>
        <form-item label="备注" :show-block="true">
          <el-input v-model="dialogData.merchantRemark" type="textarea" :rows="2" placeholder="选填"/>
        </form-item>
      </form-items>
      <template #footer>
        <page-button @click="showDialog = false">取消</page-button>
        <page-button type="write" el-type="primary" @click="saveData">保存</page-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import CustomerSelect from "@/components/h5/partner/CustomerSelect.vue";
import Administrative from "@/components/h5/data/Administrative.vue";
import YqTable from "@/components/h5/table/YqTable.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import contactApi from "@/api/dz-crm/partner/contactApi";
import commonApi from "@/api/commonApi";
import {DICT_CUSTOMER_POSITION, KEY_CONTACT, dictName} from "@/views/h5/crm/crmDictionary";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";

export default {
  setup() {
    return {router: useRouter(), route: useRoute()};
  },
  name: "ContactList",
  components: {
    Administrative, CustomerSelect, YqTable, YqTableColumn, FormItems, FormItem,
    ListPage, ListTable, SearchCondition, FormPage, PageButton, TableButton,
  },
  data() {
    return {
      loading: false,
      searchInfo: {pageNumber: 1, pageSize: 20, searchKey: "", customerId: ""},
      dataList: [],
      positionList: [],
      showDialog: false,
      dialogData: {},
      // 常量暴露给模板用
      KEY_CONTACT,
    };
  },
  beforeRouteLeave(to, from, next) {
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    commonApi.queryUniqueDictionaryList(DICT_CUSTOMER_POSITION).then(list => this.positionList = list || []);
    if (!Util.loadPageData(this)) {
      this.resetSearch();
    }
  },
  methods: {
    dictName,
    async queryList() {
      // 空值不提交，避免空串绑到后端字段
      const params = {};
      Object.keys(this.searchInfo).forEach(key => {
        const value = this.searchInfo[key];
        if (value === "" || value === null || value === undefined) {
          return;
        }
        params[key] = value;
      });
      this.loading = true;
      try {
        const {records, totalCount} = await contactApi.queryList(params);
        this.dataList = records || [];
        this.searchInfo.totalCount = totalCount;
      } finally {
        this.loading = false;
      }
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    openDialog(row) {
      if (row) {
        // 整行回显：保存走的是全字段更新，漏字段会被写成空
        this.dialogData = JSON.parse(JSON.stringify(row));
        // 客户选择器要的是客户档案id，列表返回的就是它
        this.dialogData.customerId = this.dialogData.customerId || "";
      } else {
        this.dialogData = {keyContact: KEY_CONTACT.NO, merchantGender: null};
      }
      this.showDialog = true;
    },
    async saveData() {
      if (!this.$refs.dialogForm.validCheck()) {
        return;
      }
      const payload = JSON.parse(JSON.stringify(this.dialogData));
      // el-select 清空会给出 ""，后端 keyContact/merchantGender 是 Integer，空串绑不上会整个保存失败
      ["keyContact", "merchantGender"].forEach(key => {
        if (payload[key] === "" || payload[key] === undefined) {
          payload[key] = null;
        }
      });
      await contactApi.saveContact(payload);
      this.showDialog = false;
      this.resetSearch();
    },
    async deleteRow(id) {
      await contactApi.delete(id);
      this.queryList();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
